module.exports = __webpack_public_path__ + "img/tz01.2af3cd39.jpg";